import * as React from 'react';
import { CubesIcon } from '@patternfly/react-icons';
import {
  PageSection,
  Title,
  Button,
  EmptyState,
  EmptyStateVariant,
  EmptyStateIcon,
  EmptyStateBody,
  EmptyStateSecondaryActions,
  Text,
  TextContent,
  TextVariants,
} from '@patternfly/react-core';

export interface ISupportProps {
  sampleProp?: string;
}

// eslint-disable-next-line prefer-const
let Support: React.FunctionComponent<ISupportProps> = () => (
  <PageSection>
    <EmptyState variant={EmptyStateVariant.full}>
      <EmptyStateIcon icon={CubesIcon} />
      <Title headingLevel="h1" size="lg">
        Support
      </Title>
      <EmptyStateBody>
        <TextContent>
          <Text component="p">
            This is where the support page will go ...
          </Text>
          <Text component={TextVariants.small}>
            ... when I get around to it.
          </Text>
        </TextContent>
      </EmptyStateBody>
      <Button variant="primary">Until Then</Button>
      <EmptyStateSecondaryActions>
        <Button variant="link">Enjoy</Button>
        <Button variant="link">These</Button>
        <Button variant="link">Useless</Button>
        <Button variant="link">Buttons</Button>
        <Button variant="link">They</Button>
        <Button variant="link">Do</Button>
        <Button variant="link">Nothing</Button>
      </EmptyStateSecondaryActions>
    </EmptyState>
  </PageSection>
);

export { Support };
